import React, { useState } from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import { Inertia } from '@inertiajs/inertia'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'

const LeaderForm = ({ material }) => {
    const { flash } = usePage().props
    const [saving, setSaving] = useState(false)
    const isEdit = Boolean(material)

    const form = useForm({
        title: material?.title || '',
        sort_order: material?.sort_order ?? 0,
        document: null,
    })

    const fieldError = (key) => {
        const e = form.errors[key]
        return Array.isArray(e) ? e[0] : e
    }

    const path = isEdit ? `/admin/sia/manage/lideres/${material.id}/edit` : '/admin/sia/manage/lideres/create'

    const submit = (e) => {
        e.preventDefault()
        setSaving(true)
        const opts = {
            preserveScroll: true,
            onFinish: () => setSaving(false),
        }

        if (isEdit) {
            Inertia.post(
                route('sia.manage.lideres.update', material.id),
                {
                    _method: 'put',
                    title: form.data.title,
                    sort_order: Number(form.data.sort_order),
                    document: form.data.document,
                },
                { ...opts, forceFormData: true },
            )
            return
        }

        form.post(route('sia.manage.lideres.store'), { ...opts, forceFormData: true })
    }

    return (
        <>
            <div className="mb-5 mt-5">
                <Breadcrumbs currentPath={path} />
            </div>

            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-6">
                <h1 className="fs-2 fw-bold text-gray-900 mb-0">{isEdit ? 'Editar material' : 'Nuevo material'}</h1>
                <Link href={route('sia.manage.lideres.index')} className="btn btn-sm btn-light">
                    ← Volver al listado
                </Link>
            </div>

            {flash.success && <div className="alert alert-success mb-5">{flash.success}</div>}

            <Card className="card-flush shadow-sm">
                <Card.Body className="py-8 px-6 px-lg-10">
                    <Form onSubmit={submit}>
                        <Row className="g-4 mb-4">
                            <Col md={8}>
                                <Form.Label className="fw-bold">Título</Form.Label>
                                <Form.Control
                                    value={form.data.title}
                                    onChange={(e) => form.setData('title', e.target.value)}
                                    className={fieldError('title') ? 'is-invalid' : ''}
                                />
                                {fieldError('title') && <div className="invalid-feedback d-block">{fieldError('title')}</div>}
                            </Col>
                            <Col md={4}>
                                <Form.Label className="fw-bold">Orden</Form.Label>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    value={form.data.sort_order}
                                    onChange={(e) => form.setData('sort_order', parseInt(e.target.value, 10) || 0)}
                                    className={fieldError('sort_order') ? 'is-invalid' : ''}
                                />
                                {fieldError('sort_order') && <div className="invalid-feedback d-block">{fieldError('sort_order')}</div>}
                            </Col>
                        </Row>
                        <Row className="g-4 mb-6">
                            <Col md={8}>
                                <Form.Label className="fw-bold">Archivo PDF</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept=".pdf,application/pdf"
                                    onChange={(e) => form.setData('document', e.target.files[0] || null)}
                                    className={fieldError('document') ? 'is-invalid' : ''}
                                />
                                {isEdit && material.file_path && <Form.Text muted>Archivo actual: {material.original_filename || material.file_path}</Form.Text>}
                                {fieldError('document') && <div className="invalid-feedback d-block">{fieldError('document')}</div>}
                            </Col>
                        </Row>
                        <Button type="submit" variant="primary" disabled={saving || form.processing}>
                            {isEdit ? 'Guardar cambios' : 'Crear material'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </>
    )
}

LeaderForm.layout = (page) => <Layout title={page.props.material?.id ? 'Editar material' : 'Nuevo material'}>{page}</Layout>

export default LeaderForm
